import { render, staticRenderFns } from "./environmentIndustry.vue?vue&type=template&id=090f2ceb&"
import script from "./environmentIndustry.vue?vue&type=script&lang=js&"
export * from "./environmentIndustry.vue?vue&type=script&lang=js&"
import style0 from "./environmentIndustry.vue?vue&type=style&index=0&id=090f2ceb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports